"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DEFAULT_SESSION_NAME = void 0;
// eslint-disable-next-line import/prefer-default-export
var DEFAULT_SESSION_NAME = 'roptoSession';
exports.DEFAULT_SESSION_NAME = DEFAULT_SESSION_NAME;